import {DBxEvent} from "cartovista";
import {get} from "cartovistaExtend/appTools/Alerts";
import {login, logout, ping} from "cartovistaExtend/utils/ServerRequests";
import "styles/AuthSession.css";
import { Modal } from 'bootstrap';

    var loginModalHtml = '<div class="modal fade" id="AuthSession_modal" data-bs-keyboard="false" tabindex="-1" role="dialog">' +
                            '<div class="modal-dialog" role="document">' +
                                '<div class="modal-content">' +
                                    '<div class="modal-header">' +
                                        '<h4 class="modal-title">Authentification</h4>' +
                                    '</div>' +
                                    '<div class="modal-body">' +
                                        '<h5><small><em>Veuillez entrer le nom d\'utilisateur et le mot de passe pour accéder à l\'application.</em></small></h5>' +
                                        '<form id="AuthSession_form" role="form">' +
                                            '<div class="form-group">' +
                                                '<label for="AuthSession_usernameInput">Nom d\'utilisateur</label>' +
                                                '<input type="text" class="form-control" id="AuthSession_usernameInput">' +
                                            '</div>' +
                                            '<div class="form-group">' +
                                                '<label for="AuthSession_passwordInput">Mot de passe</label>' +
                                                '<input type="password" class="form-control" id="AuthSession_passwordInput">' +
                                            '</div>' +
                                            '<div id="AuthSession_alertContainer"></div>' +
                                            '<div id="AuthSession_submitBtnContainer" class="container-fluid">' +
                                                '<button type="submit" id="AuthSession_submitBtn" form="AuthSession_form" class="btn btn-primary float-end">Soumettre</button>' +
                                                '<button type="button" class="btn btn-outline-secondary float-start" data-bs-dismiss="modal" title="Annuler">Annuler</button>' + 
                                            '</div>' +
                                        '</form>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

    var logoutBtnHtml = '<button id="AuthSession_logoutBtn" class="k-button k-button-icon" title="Se déconnecter">' +
                            '<span class="bi bi-box-arrow-right"></span>' +
                        '</button>';

    var loginBtnHtml = '<button disabled id="AuthSession_loginBtn" class="k-button k-button-icon k-state-disabled" title="Se connecter">' +
                            '<span class="bi bi-person-circle"></span>' +
                        '</button>';

    export default class AuthSession {
      constructor() {
        this._storeClientInfo();
        this._startTokenExpirationTimer();
        if (C.APP_TOOLS.AUTH_SESSION.USER.PING_INTERVAL) {
            this._pingInterval = this._startPingInterval();
        }
        this._$loginModal = $(loginModalHtml);
        this._loginModal = new Modal(this._$loginModal);
        this._$loginForm = this._$loginModal.find("#AuthSession_form");
        this._$submitLoginBtn = this._$loginModal.find("#AuthSession_submitBtn");
        this._$usernameInput = this._$loginModal.find("#AuthSession_usernameInput");
        this._$passwordInput = this._$loginModal.find("#AuthSession_passwordInput");
        this._$logoutBtn = $(logoutBtnHtml);
        this._$loginBtn = $(loginBtnHtml);
        this._$alertContainer = this._$loginModal.find("#AuthSession_alertContainer");
        this._$loginForm.submit(this._onLoginFormSubmitted.bind(this));
        this._$logoutBtn.click(this._onLogoutBtnClicked.bind(this));
        this._$loginBtn.click(function(){this._loginModal.show();}.bind(this));
        $("body").append(this._$loginModal);
        $(".cv-headerAction").prepend(this._$logoutBtn);
        $(".cv-headerAction").prepend(this._$loginBtn);

        document.querySelector('#AuthSession_modal').addEventListener('hide.bs.modal', function(){
            $(".modal-backdrop").removeAttr("id");
            this._$alertContainer.empty();
            this._$loginForm[0].reset();
        }.bind(this));

        document.querySelector('#AuthSession_modal').addEventListener('shown.bs.modal', function(){
            $(".modal-backdrop").attr("id", "AuthSession_modalBackdrop");
        });
      }

    _storeClientInfo() {
        if (window.sessionStorage.getItem("username") && window.sessionStorage.getItem(window.sessionStorage.getItem("username")) && new Date() < new Date(JSON.parse(window.sessionStorage.getItem(window.sessionStorage.getItem("username"))).TOKEN_EXPIRATION_TS*1000)) {
            C.APP_TOOLS.AUTH_SESSION.USER = JSON.parse(window.sessionStorage.getItem(window.sessionStorage.getItem("username")));
            $('[data-cv-role="preloader"]').attr("data-cv-role", null);
        } else{
            $('[data-cv-role="preloader"]').attr("id", null);
        }
    };

    _removeClientInfo() {
        C.APP_TOOLS.AUTH_SESSION.USER = {TOKEN:""};
        window.cartovista.dispatchEvent(new DBxEvent("AuthSession_UserLoggedOut"));
        window.sessionStorage.removeItem(window.sessionStorage.getItem("username"))
        window.sessionStorage.removeItem("username");
    };

    _onLoginFormSubmitted(evt) {
        evt.preventDefault();
        this._$loginModal.find(".has-error").removeClass("has-error");
        var username = this._$usernameInput.val(),
            password = this._$passwordInput.val();
        if (!username) {
            this._$alertContainer.html(get("AuthSession_MissingUsernameInput"));
            this._$usernameInput.parent().addClass("has-error");
        } else if (!password) {
            this._$alertContainer.html(get("AuthSession_MissingPasswordInput"));
            this._$passwordInput.parent().addClass("has-error");
        } else {
            this._sendCredentials(username, password);
        }
    };

    _sendCredentials(username, password) {
        this._disableSubmitBtn();
        this._$alertContainer.empty();
        login(username, password)
        .then(this._onLoginSuccess.bind(this, username))
        .catch(this._onLoginError.bind(this));

    };

    _onLoginSuccess(username, userInfo) {
        this._enableSubmitBtn();
        this._disableLoginBtn();
        this._enableLogoutBtn();
        window.sessionStorage.setItem("username", username);
        window.sessionStorage.setItem(username, JSON.stringify(userInfo));
        C.APP_TOOLS.AUTH_SESSION.USER = userInfo;
        this._startTokenExpirationTimer();
        if (C.APP_TOOLS.AUTH_SESSION.USER.PING_INTERVAL) {
            this._pingInterval = this._startPingInterval();
        }
        this._loginModal.hide();
        window.cartovista.dispatchEvent(new DBxEvent("AuthSession_UserLoggedIn"));
    };

    _onLoginError(error){
        console.error(error);
        this._enableSubmitBtn();
        this._$alertContainer.html(get("AuthSession_LoginError", {"error" : error}));
        this._removeClientInfo();
    }

    _logout() {
        logout();
        this._disableLogoutBtn();
        this._enableLoginBtn();
        this._removeClientInfo(); 
    };

    _disableSubmitBtn() {
        this._$submitLoginBtn.prop("disabled", true);
    };

    _disableLoginBtn() {
        this._$loginBtn.prop("disabled", true);
        this._$loginBtn.addClass("k-state-disabled");
    };

    _disableLogoutBtn() {
        this._$logoutBtn.prop("disabled", true);
        this._$logoutBtn.addClass("k-state-disabled");
    };

    _enableSubmitBtn() {
        this._$submitLoginBtn.prop("disabled", "");
    };

    _enableLoginBtn() {
        this._$loginBtn.prop("disabled", "");
        this._$loginBtn.removeClass("k-state-disabled");
    };

    _enableLogoutBtn() {
        this._$logoutBtn.prop("disabled", "");
        this._$logoutBtn.removeClass("k-state-disabled");
    };

    _onLogoutBtnClicked() {
        this._logout();
    };

    _startTokenExpirationTimer() {
        setTimeout(function() {
            if (C.APP_TOOLS.AUTH_SESSION.USER.PING_INTERVAL) {
                window.clearInterval(this._pingInterval);
            }
            this._removeClientInfo();
            this._loginModal.show();
            if(typeof C.APP_TOOLS.AUTH_SESSION.USER.TOKEN_DURATION != "undefined") this._$alertContainer.html(get("AuthSession_TokenExpired"));
            this._enableLoginBtn();
            this._disableLogoutBtn();
        }.bind(this), C.APP_TOOLS.AUTH_SESSION.USER.TOKEN_DURATION);
    };

    _startPingInterval() {
        return setInterval(ping, C.APP_TOOLS.AUTH_SESSION.USER.PING_INTERVAL * 60000);
    };

}
